import request from '@/plugins/axios'

// 代理商列表
export const apiAgentListAll = (params: any = {}) => request.get('agent.index/lists', { params })
// 新增代理商
export const apiAgentEdit = (data: any = {}) => request.post('agent.index/edit', data)
// 修改状态
export const apiChangeStatus = (data: any = {}) => request.post('agent.index/status', data)
// 重置密码
export const apiResetPassword = (data: any = {}) => request.post('agent.index/password', data)
// 预存充值
export const apiRecharge = (data: any = {}) => request.post('agent.index/recharge', data)